export const fr = {
  companySettings: {
    title: "Paramètres de l'entreprise",
    subtitle: 'Personnalisez les paramètres de votre entreprise',
    menu: {
      general: 'Personnalisation',
      administration: 'Administration',
      departments: 'Départements',
      polling: 'Sondages',
      slack: 'Slack',
      microsoftTeams: 'Microsoft Teams',
    },
    generalSettings: {
      title: "Personnalisation de l'entreprise",
      pageTitle: 'Paramètres › Personnalisation',
      logo: {
        label: "Logo de l'entreprise",
        hint: "Le téléchargement de votre logo d'entreprise l'ajoutera à différentes parties du site pour que les employés de {{companyName}} puissent le voir.",
      },
      badge: {
        label: "Badge de l'entreprise",
        hint: "Le téléchargement de votre badge d'entreprise l'ajoutera à différentes parties du site pour que les employés de {{companyName}} puissent le voir. Le badge est destiné à être une image carrée plus petite.",
      },
      color: {
        label: "Couleur de l'entreprise",
        hint: 'Vous pouvez personnaliser davantage Purposely en ajoutant la couleur principale de votre entreprise.',
      },
      saveButton: 'Enregistrer',
      successMessage: "Paramètres de l'entreprise mis à jour avec succès",
    },
    departments: {
      title: 'Départements',
      pageTitle: 'Mon entreprise › Paramètres › Départements',
      subtext: 'Gérez les départements de votre entreprise',
      table: {
        columns: {
          name: 'Nom',
        },
        actions: {
          remove: 'Supprimer',
          activate: 'Activer',
          rename: 'Renommer',
        },
        emptyState: {
          title: 'Pas encore de départements',
          description:
            "Il semble que vous n'ayez pas encore ajouté de départements.",
        },
      },
    },
    administrationSettings: {
      title: 'Paramètres d’administration',
      pageTitle: 'Paramètres › Administration',
      requireHourApprovalLabel:
        "Exiger l'approbation manuelle des heures soumises",
      successMessage: 'Paramètres d’administration mis à jour avec succès',
      requireHourApprovalHint:
        'Lorsque cette option est désactivée, les heures soumises seront automatiquement approuvées sans examen manuel.',
    },
    departmentForm: {
      validation: {
        required: 'Obligatoire',
      },
      placeholder: 'Ajouter un nouveau département',
      button: 'Ajouter un département',
      successMessage: 'Enregistré',
    },
    confirmChangeDepartment: {
      removeTitle: 'Supprimer le département',
      activateTitle: 'Activer le département',
      removeConfirm:
        "Êtes-vous sûr de vouloir supprimer ce département ? Tous les employés affectés à ce département devront s'inscrire dans un autre département.",
      activateConfirm: 'Êtes-vous sûr de vouloir activer ce département ?',
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    renameDepartment: {
      title: 'Renommer le département',
      description:
        'Veuillez noter que ce département sera renommé pour toutes les personnes qui y sont affectées.',
      placeholder: 'Saisir le nom',
      validation: {
        required: 'Obligatoire',
      },
      buttons: {
        save: 'Enregistrer',
      },
      successMessage: 'Enregistré',
    },
    polling: {
      title: 'Page des sondages',
      pageTitle: 'Paramètres › Sondages',
      description:
        'Créez et gérez des sondages pour votre entreprise. Utilisez cette fonctionnalité pour recueillir des opinions, prendre des décisions et engager efficacement votre équipe.',
      table: {
        title: 'Sondages de {{companyName}}',
        columns: {
          name: 'Nom',
          options: 'Options',
          votesCast: 'Votes exprimés',
          startDate: 'Date de début',
          endDate: 'Date de fin',
        },
        actions: {
          viewResults: 'Voir les résultats',
          edit: 'Modifier',
          delete: 'Supprimer',
        },
        headerActions: {
          createPoll: 'Créer un sondage',
        },
        emptyState: {
          title: 'Aucun sondage',
          description:
            "Il semble que vous n'ayez pas encore créé de sondages. Pour créer un nouveau sondage, appuyez sur le bouton 'Créer un sondage'.",
        },
      },
      featureNotAvailable: {
        title: 'Fonctionnalité de sondage non disponible',
        description:
          "Il semble que la fonctionnalité de sondage ne soit pas activée pour votre entreprise. Veuillez contacter votre administrateur pour plus d'informations.",
      },
      formModal: {
        titles: {
          create: 'Créer un sondage',
          edit: 'Modifier le sondage',
        },
        fields: {
          name: {
            label: 'Nom',
          },
          description: {
            label: 'Description',
          },
          startDate: {
            label: 'Date de début du sondage',
          },
          endDate: {
            label: 'Date de fin du sondage',
          },
        },
        buttons: {
          create: 'Créer un sondage',
          update: 'Mettre à jour le sondage',
        },
        validation: {
          required: 'Obligatoire',
          minOptions: 'Au moins deux options sont requises',
          minOptionsForPoll:
            'Au moins deux options sont requises pour un sondage',
        },
        alerts: {
          created: 'Sondage créé avec succès',
          updated: 'Sondage mis à jour avec succès',
        },
      },
    },
    slack: {
      title: 'Paramètres Slack',
      pageTitle: 'Mon entreprise › Paramètres › Slack',
      description:
        'Gérez les préférences de votre entreprise pour le Bot Slack Purposely',
      channelSubscription: {
        label: 'Choisissez un canal public',
        hint: "C'est dans ce canal que le Bot Slack Purposely enverra des messages",
        updateButton: 'Mettre à jour',
        successMessage: 'Abonnement au canal Slack mis à jour',
        validation: {
          required: 'Obligatoire',
        },
      },
      onboarding: {
        title: 'Purposely sur Slack',
        description:
          "Recevez des mises à jour lorsque de nouvelles missions bénévoles sont publiées, que des détails changent, que des collègues rejoignent ou que des événements se terminent — afin d'être toujours informé(e).",
      },
    },
    slackPreferences: {
      title: 'Préférences de notification',
      description:
        'Personnalisez les messages que le bot Slack Purposely doit envoyer',
      notifications: {
        opportunityCreated: 'Nouvelle opportunité créée',
        opportunityCompleted: 'Opportunité terminée',
        opportunityUpdated: "Détails de l'opportunité mis à jour",
        employeeJoined: 'Un employé a rejoint une opportunité',
        employeeDm: 'Messages directs du bot Slack Purposely',
      },
      updateButton: 'Mettre à jour',
      successMessage: 'Préférences Slack mises à jour',
    },
    microsoftTeams: {
      title: 'Paramètres Teams',
      pageTitle: 'Mon entreprise › Teams',
      description:
        'Gérez les préférences de votre entreprise pour le Bot Teams Purposely',
      onboarding: {
        title: 'Purposely sur Teams',
        description:
          "Recevez des mises à jour lorsque de nouvelles missions bénévoles sont publiées, que des détails changent, que des collègues rejoignent ou que des événements se terminent — afin d'être toujours informé(e).",
      },
    },
    microsoftTeamsAuth: {
      buttonText: 'Ajouter à Microsoft Teams',
      hint: '*Il semble que vous ne vous soyez pas connecté à Purposely avec votre compte Microsoft. Veuillez vous reconnecter avec Microsoft SSO pour lier votre entreprise à Microsoft Teams.',
      alt: 'Ajouter le bot à Teams',
    },
    microsoftTeamsPreferences: {
      title: 'Préférences de notification',
      description:
        'Personnalisez les messages que le bot Teams Purposely doit envoyer',
      notifications: {
        opportunityCreated: 'Nouvelle opportunité créée',
        opportunityCompleted: 'Opportunité terminée',
        opportunityUpdated: "Détails de l'opportunité mis à jour",
        employeeJoined: 'Un employé a rejoint une opportunité',
      },
      updateButton: 'Mettre à jour',
      successMessage: 'Préférences Teams mises à jour',
    },
  },
}
